import {connect} from 'react-redux';
import {formValueSelector} from 'redux-form';
import EntryDetailSquadChangeModal from './EntryDetailSquadChangeModal.jsx';
import {
  validateEntryDetailSquadChangeForm,
  handleSquadChangeSave,
  handleSquadChangeCancel,
  handleChangeSquadDateChanged
} from './actions';

const selector = formValueSelector('adminEntryDetailSquadChangeForm');

const mapStateToProps = state => ({
  validate: validateEntryDetailSquadChangeForm,
  visible: state.admin.entryDetail.showSquadChangeModal,
  minDate: state.admin.entryDetail.tournament.startDate,
  maxDate: state.admin.entryDetail.tournament.endDate,
  availableSquads: selector(state, 'availableSquads')
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(handleSquadChangeSave(data)),
  onCancel: () => dispatch(handleSquadChangeCancel()),
  onDateChange: data => dispatch(handleChangeSquadDateChanged(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(EntryDetailSquadChangeModal);



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryDetailSquadChangeModalContainer.jsx